import script from "./TripsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripsView.vue?vue&type=script&setup=true&lang=ts"

import "./TripsView.vue?vue&type=style&index=0&id=70fc606e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fc606e"]])

export default __exports__